import { Injectable } from '@angular/core';
import { CalendarInt, CalendarItemInt } from '@app/interfaces/calendar.interface';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  calendars: CalendarInt;
  lang: any;

  constructor(private _translateService: TranslateService) { }

  createCalendar(currentDay, daySelected): CalendarInt {
    const currentMonth = currentDay.month();
    this.lang = this._translateService?.currentLang.split('-');
    
    const titleMonth = moment().locale(this.lang[0]).month(currentMonth).format('MMMM');

    const dayOfMonth = this.onSelectMonth(currentDay, moment(), daySelected, currentMonth);
    const calendarMap = this.transformMatrix(dayOfMonth, 7);

    return {
        titleMonth,
        calendarMap,
        id: currentMonth
      };
  }

  getFirstDay(currentDay) {
    const date = currentDay;
    const newDate = moment({day: 1, month: moment().month(), year: date.year()});

    return newDate;
  }

  onSelectMonth(firstDay, currentDay, daySelected, currentMonth): Array<CalendarItemInt> {
    const date = moment(firstDay);
    const calendar = date.daysInMonth();
    const initDay = date.weekday(); 
    const complete = initDay > 0 ? initDay - 1 : 6;    
    const initDate = moment(firstDay).subtract(complete, 'd');
    const array = [moment(initDate)];
    const lastDay = moment(firstDay).add((calendar - 1), 'd');

    while (initDate.toDate() < lastDay.toDate()) {
      initDate.add(1, 'd');
      array.push(moment(initDate));
    }

    const x = 35 - array.length;

    for (let i = 0; i < x; i++) {
      array.push(null);
    }

    return array.map((m) => {
      if (m) {
        return {
          selected: m.isSame(daySelected ?? currentDay, 'day') && m.month() == currentMonth,
          disabled: m.diff(currentDay.toDate(), 'days', false) < 0 || m.month() < currentMonth,
          date: m,
        }
      }

      return null;
    });
  }

  transformMatrix(array, columns): CalendarItemInt[][] {
    let matrix = [];

    while (array.length) {
      matrix.push(array.splice(0, columns));
    }

    return matrix;
  }

  createMonthsCalendar(currentDate) {
    let actual = null;
    let monthList = {};

    for (let i = 0; i <= 11; i++) {

      let dateCreate = moment(currentDate).add(i, 'month');
      let year = dateCreate.year()

      if (actual != year) {
        monthList[year] = []
        actual = year;
      }

      monthList[year].push(
        {
          dateCreate,
          selected: true,
          year,
          link: `list-item-${dateCreate.month()}`
        }
      );
    }

    return this.objectToArray(monthList);
  }

  objectToArray(obj: any): any[] {
    if (obj) {
      return Object.keys(obj).map(key => ({ key, value: obj[key] }));
    }
    return [];
  }

  createCalendars(currentDate, daySelected) {
    let actual = null;
    let monthsList = [];

    for (let i = 0; i <= 11; i++) {

      let dateCreate = moment(currentDate).add(i, 'month');

      monthsList.push(
        this.createCalendar(dateCreate, daySelected)
      );
    }

    return monthsList;
  }

  navToMonth(date, prefix = 'list-item-') {
    let month = date.month();
    const id = `${prefix}${month}`;
    let element = null;
    
    return () => { 
      setTimeout( () => {
        element = document.getElementById(id);
        
        if (element) {
          element.scrollIntoView();
        }

        return element;
      }, 1000);

      return id;
    }
  }


}